import { render, staticRenderFns } from "./ElementChat.vue?vue&type=template&id=28af06f9&"
import script from "./ElementChat.vue?vue&type=script&lang=js&"
export * from "./ElementChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports